import { WithDefaultLayout } from "@/components/DefautLayout";
import { Page } from "@/types/Page";
import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import DocumentCategoryNavigation from "@/components/Documentation/DocumentCategoryNavigation";
import DocumentationDetails from "@/components/Documentation/DocumentationDetails";
import DocumentationSlides from "@/components/Documentation/DocumentationSlides";
import { documentationImage } from "@/types/DocumentationImages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { Button, Dropdown, MenuProps } from "antd";
import TestimonyCarousel from "@/components/testimony/TestimonyCarousel";

const items: MenuProps["items"] = [
  {
    key: "2024",
    label: <a>2024</a>,
  },
  // {
  //     key: '2025',
  //     label: (
  //         <a>
  //             2025 (coming soon)
  //         </a>
  //     ),
  // },
  {
    key: "2026",
    label: <a>2026 (coming soon)</a>,
  },
];
const Home = () => {
  const [selectCategory, setSelectCategory] = useState<string>("All");
  const [selectYear, setSelectYear] = useState<number>(2024);
  const handleMenuClick: MenuProps["onClick"] = (e) => {
    setSelectYear(parseInt(e.key));
  };

  const router = useRouter();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [router.asPath]);

  // const images = ["/images/home-bg.webp", "/images/philosophy-bg.webp", "/images/program-bg.webp"]
  // const images = documentationImage
  //     .filter(image => image.year === 2024)
  //     .slice(0, 3).map((image) => image.image);

  const imageMobile = [
    "/images/documentation/background/background_mobile.png",
  ];
  const imagesDesktop = [
    "/images/documentation/background/background_desktop.png",
  ];

  const filteredImages = documentationImage.filter(
    (img) =>
      img.year === selectYear &&
      (selectCategory === "All" || img.category === selectCategory),
  );

  return (
    <div className="relative">
      <div className="relative overflow-hidden">
        <div className="flex flex-1 flex-col justify-center items-center">
          {/* <div className="absolute inset-0 bg-black bg-opacity-100 z-5 pointer-events-none"></div> */}
          <div className="absolute top-[35%] left-1/2 flex flex-col gap-3 items-center -translate-y-1/2 -translate-x-1/2 z-10">
            <h1 className="text-3xl sm:text-4xl text-white font-bold text-center drop-shadow-[0_0_6px_rgba(0,0,0,1)]">
              Gallery
            </h1>
            <h1 className="text-2xl md:text-3xl text-white text-center drop-shadow-[0_0_6px_rgba(0,0,0,1)]">
              Various Exciting Activities at the
              <br className="block md:hidden" /> IIT Challenge{" "}
              <span className="inline-flex items-center space-x-1">
                <span>{selectYear}</span>
                <Dropdown
                  menu={{ items, onClick: handleMenuClick }}
                  trigger={["click"]}
                >
                  <Button
                    className="text-white font-bold w-6 h-6 flex items-center justify-center bg-defaultBlue hover:bg-darkBlue border-0"
                    icon={
                      <FontAwesomeIcon
                        icon={faChevronDown}
                        style={{ fontSize: "0.75rem" }}
                      />
                    }
                  />
                </Dropdown>
              </span>
            </h1>
          </div>

          <DocumentationSlides
            imagesMobile={imageMobile}
            imagesDesktop={imagesDesktop}
          />
        </div>
        <h1 className="text-3xl text-black font-bold text-center mt-8">
          Photos {selectYear}
        </h1>
        <DocumentCategoryNavigation
          selectedCategory={selectCategory}
          onSelectCategory={setSelectCategory}
          selectedYear={selectYear}
        />
      </div>

      {filteredImages.length > 0 ? (
        <DocumentationDetails year={selectYear} category={selectCategory} />
      ) : (
        <div className="w-10/12 mx-auto flex flex-col items-center justify-center -mt-10 -mb-10">
          <h2 className="text-2xl font-bold text-gray-600 text-center pb-20">
            <span className="block text-xl md:text-3xl py-1">Coming Soon</span>
            <span className="block text-sm md:text-xl font-medium opacity-90">
              Your Memories are on the way
            </span>
          </h2>
        </div>
      )}
      <div
        className="relative bg-center bg-cover he overflow-hidden mt-4 -mb-24 pb-20"
        style={{
          backgroundImage:
            'url("/images/documentation/background/testimony_background.jpg")',
        }}
      >
        <div className="w-full h-full absolute bg-darkBlue bg-opacity-50 pointer-events-none" />

        <div className="relative z-10">
          <TestimonyCarousel year={selectYear} />
        </div>
      </div>
    </div>
  );
};

const Render = () => {
  return <div>{Home()}</div>;
};

const documentation: Page = () => {
  return <div>{Render()}</div>;
};

documentation.layout = WithDefaultLayout;
export default documentation;
